export const SMALL_RESOURCE_FOOTER_HEIGHT = '2.25rem';
export const SMALL_RESOURCE_FOOTER_MIN_HEIGHT = SMALL_RESOURCE_FOOTER_HEIGHT;
export const SMALL_RESOURCE_FOOTER_PADDING = '0.25rem 0.75rem';
